import React from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console for debugging
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    // Update state with error details
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // You can also log the error to an error reporting service here
    // Example: logErrorToService(error, errorInfo);
  }

  handleReload = () => {
    // Clear error state and reload the page
    window.location.reload();
  };

  handleGoHome = () => {
    // Clear error state and navigate to home
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      return (
        <div className="error-boundary-container">
          <div className="error-boundary-content">
            <div className="error-icon">⚠️</div>
            <h1 className="error-title">حدث خطأ غير متوقع</h1>
            <h2 className="error-subtitle">Unexpected Application Error!</h2>
            <p className="error-message">
              نعتذر، حدث خطأ غير متوقع في التطبيق. يرجى المحاولة مرة أخرى.
            </p>
            <p className="error-message-en">
              We apologize, an unexpected error occurred in the application. Please try again.
            </p>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="error-details">
                <summary>تفاصيل الخطأ (للمطورين) / Error Details (For Developers)</summary>
                <pre className="error-stack">
                  {this.state.error.toString()}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            )}

            <div className="error-actions">
              <button 
                className="error-button error-button-primary" 
                onClick={this.handleReload}
              >
                إعادة تحميل الصفحة / Reload Page
              </button>
              <button 
                className="error-button error-button-secondary" 
                onClick={this.handleGoHome}
              >
                العودة للصفحة الرئيسية / Go to Home
              </button>
            </div>

            <div className="error-support">
              <p>
                إذا استمرت المشكلة، يرجى التواصل مع الدعم الفني:
              </p>
              <p>
                If the problem persists, please contact support:
              </p>
              <a 
                href="mailto:support@mazraaonline.com" 
                className="error-support-link"
              >
                support@mazraaonline.com
              </a>
            </div>
          </div>
        </div>
      );
    }

    // If no error, render children normally
    return this.props.children;
  }
}

export default ErrorBoundary;


